import id from './[id].json';

const blog = {
	"pages.blog.id": id
};

export { blog };